import type { ViewComponent } from "@frui.ts/views";
import type SubLedgerNewReportViewModel from "../../../../viewModels/finance/subLedger/SubLedgerNewReportViewModel";
import { observer } from "mobx-react-lite";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import React from "react";
import { Input } from "@frui.ts/bootstrap";
import CountrySelect from "../../../common/countrySelect";
import FormGroup from "../../../../controls/formGroup";
import AdvancedInput, { Transformation } from "@edaz/edazkit/controls/AdvancedInput";

export const ChargeParameters: ViewComponent<SubLedgerNewReportViewModel> = observer(({ vm }) => {
  return (
    <div style={{ paddingBottom: "2.5rem" }}>
      <h5>{vm.translate("chargeParameters.name")}</h5>

      <div className="row">
        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translate("chargeParameters.chargeId")}*</Form.Label>
          <Input
            target={vm.charge}
            property="id"
            placeholder={vm.translate("chargeParameters.chargeId")}
            disabled={!vm.canEditCharge}
          />
        </Form.Group>

        <FormGroup as={Col} md={6} className="col-xxl-4" target={vm.charge} property="countryId">
          <Form.Label>{vm.translateAttribute("licensePlate.countryId")}</Form.Label>
          <CountrySelect
            allowEmpty
            vm={vm.countrySelectViewModel}
            placeholder={vm.translateAttribute("licensePlate.countryId")}
            disabled={!vm.canEditCharge}
          />
        </FormGroup>

        <Form.Group as={Col} lg={2} xl={2}>
          <Form.Label>{vm.translateAttribute("licensePlate.licensePlate")}*</Form.Label>
          <AdvancedInput
            target={vm.charge}
            property="licensePlate"
            placeholder={vm.translateAttribute("licensePlate.licensePlate")}
            transformation={Transformation.UpperCased}
            disabled={!vm.canEditCharge}
          />
        </Form.Group>

        <Form.Group as={Col} lg={4} xl={4}>
          <Form.Label>{vm.translateAttribute("charge.email")}*</Form.Label>
          <Input
            target={vm.charge}
            property="email"
            placeholder={vm.translateAttribute("charge.email")}
            disabled={!vm.canEditCharge}
          />
        </Form.Group>
      </div>
    </div>
  );
});
